export const settingsPaths = {
    settings: '/settings',
};
